module.exports = __webpack_public_path__ + "static/img/dj1-5.35045b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/dj1-5.png
// module id = 792
// module chunks = 0